import React from 'react';
import CustomDataTableComponent from '../../../../../../commons/components/custom-data-table/custom-data-table.component';
import {
  CustomDataTableConfig,
  HeadCell,
} from '../../../../../../commons/components/custom-data-table/custom-data-table-config.model';
import { User } from '../../../../../../models/interfaces/User.interface';
import { useNavigate } from 'react-router-dom';
import routeService from '../../../../../../routes/route.service';

interface UserTableComponentProps {
  users: User[];
  onSelect?: Function;
}

export default function UserTableComponent(props: UserTableComponentProps) {
  const navigate = useNavigate();

  const headCells: HeadCell[] = [
    { id: 'id', field: 'id', label: 'ID' },
    { id: 'name', field: 'name', label: 'Name' },
    { id: 'surname', field: 'surname', label: 'Surname' },
    { id: 'phoneNr', field: 'phoneNr', label: 'Telephone number' },
    { id: 'email', field: 'email', label: 'Email' },
    { id: 'locked', label: 'Is locked', getFieldValueFunc: (item: User) => (item.locked ? 'Yes' : 'No') },
    { id: 'creditBudget', field: 'creditBudget', label: 'Credit budget' },
  ];

  const tableConfig: CustomDataTableConfig = {
    tableName: 'Users',
    rowsPerPage: 10,
    headCells,
    highlightRowColorFunc: (item: User): string | null => (item?.locked ? 'red' : null),
  };

  const handleSelectRow = (selectedUser: User) => {
    if (props?.onSelect) {
      props.onSelect(selectedUser);
    } else if (selectedUser?.id) {
      navigate(routeService.getAndFillUserDetailPath(selectedUser.id));
    }
  };

  return <CustomDataTableComponent tableConfig={tableConfig} data={props.users} onSelect={handleSelectRow} />;
}
